import _ from 'lodash';
const moneyFormat = (amount, { minimumFractionDigits } = { minimumFractionDigits: 2 }) => {

	if(_.isString(amount) && amount.includes('$')) {
		amount = amount.replace('$', '');
		amount = amount.replace(',', '');
	}
	return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits }).format(amount);
};

export const moneyFormatFromCents = (amount, options) => {
	return moneyFormat((amount / 100).toFixed(2), options);
};

export default moneyFormat;